/**
 * KAN-871: личный аккаунт менеджера (personal_manager_id из зеркала
 * accounts_gateway). С него нет рассылки, и в кабинете над ним нет действий,
 * которые backend отклоняет (409 code=personal_account): включение, проверка
 * @SpamBot, смена профиля и прокси, прямая отправка. Только просмотр.
 */
import type { TelegramAccount } from '@/types/telegramAccount';

export function isPersonalTelegramAccount(
  account: Pick<TelegramAccount, 'personal_manager_id'>
): boolean {
  return !!(account.personal_manager_id ?? '').trim();
}

/** Подсказка у заблокированной кнопки смены профиля. */
export const PERSONAL_PROFILE_LOCKED =
  'Личный аккаунт менеджера: профиль меняет сам менеджер в Telegram';
